/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';
export const VialsIconConfig = {
  name: 'VialsIcon',
  height: 512,
  width: 640,
  svgPath: 'M72 64h24v240c0 44.1 35.9 80 80 80s80-35.9 80-80V64h24c4.4 0 8-3.6 8-8V8c0-4.4-3.6-8-8-8H72c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm72 0h64v96h-64V64zm480 384H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM360 64h24v240c0 44.1 35.9 80 80 80s80-35.9 80-80V64h24c4.4 0 8-3.6 8-8V8c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm72 0h64v96h-64V64z',
  yOffset: '',
  xOffset: '',
  transform: ''
};
export default createIcon(VialsIconConfig);
//# sourceMappingURL=vials-icon.js.map